import React from "react";
import {GROUPS} from "../../../../utils/constants";
import {OptionButton} from "../../../../designSystem/components/OptionButton";

export const GroupButtons = ({
  userRole='god',
  userOrganizationGroup=[],
  selectedGroup,
  onChangeSelectedGroup,
}) => {
  return (
    <div className="flex gap-3 overflow-x-scroll">
      {GROUPS
        .filter(group => {
          if (userRole === 'god') return true
          return userOrganizationGroup.includes(group.name)
        })
        .map(group => (
          <OptionButton
            key={group.name}
            isSelected={selectedGroup === group.name}
            onClick={() => onChangeSelectedGroup(group)}
            icon={group.icon}
            label={group.shortName}
          />
        ))
      }
    </div>
  )
}
